import type {
  DeliveryChargeFulfillmentType,
  SupplierProductGetResponseChildType,
} from "@sellar-io/api-v2/types";
import {
  findProductFulfillmentTypeDeliveryCharge,
  formatCurrency,
} from "@sellar-io/common";
import { useFulfillmentTypeList } from "../../../../../../../hooks/api/v2/fulfillmentType/useFulfillmentTypeList";

export const ProductCategoryItemDeliveryChargeRow = ({
  product,
  name,
  fulfillmentType,
}: {
  product: SupplierProductGetResponseChildType;
  fulfillmentType: "direct" | "courier" | "collection" | "haulier";
  name: string;
}) => {
  const fulfillmentTypeQuery = useFulfillmentTypeList(
    {
      query: [
        {
          type: "FulfillmentType",
          value: fulfillmentType as DeliveryChargeFulfillmentType,
          modifier: "EQUALS",
        },
      ],
      sortBy: "createdAt",
      sortDir: "desc",
    },
    {
      enabled: ["courier", "direct", "ups", "haulier"].includes(
        fulfillmentType,
      ),
    },
  );

  const deliveryCharge =
    findProductFulfillmentTypeDeliveryCharge({
      fulfillmentTypeContainerDeliveryCharges:
        fulfillmentTypeQuery.data?.pages[0]?.[0]
          ?.FulfillmentTypeContainerDeliveryCharges,
      product: {
        ...product,
        displayUnit: product.unit,
      },
    })?.charge ?? 0;

  return (
    <tr className={"bg-white"}>
      <td className={"left-0 bg-white px-4 py-1"}>
        <div className={"flex items-center gap-2"}>{name}</div>
      </td>
      <td className={"flex items-center gap-2 px-4 py-1"}>
        {formatCurrency(deliveryCharge)}
      </td>
    </tr>
  );
};
